module.exports = __webpack_public_path__ + "static/media/csrd_dashboard_icon3.fcab77c1.svg";